import * as React from 'react';
import * as I18n from 'i18n-js';
import * as classNames from 'classnames';

const numBarsToShow = 8;
const MINT_INVENTORY_CONDITION = 'mint-inventory';

interface Props {
  slug: string;
  displayName: string;
  showTooltip?: boolean;
  alignTooltip?: string; // left or right. Defaults to center.
}

export default class ConditionDisplay extends React.Component<Props, null> {
  get slug() {
    if (this.props.slug === MINT_INVENTORY_CONDITION) {
      return 'mint';
    }

    return this.props.slug;
  }

  renderTooltip() {
    if (!this.props.showTooltip) { return false; }

    return (
      {
        'data-tooltip-text': I18n.t(`commons.specList.conditions.${this.props.slug}`),
        'data-tooltip-align': this.props.alignTooltip,
      }
    );
  }

  renderBars() {
    const bars = [];
    for (let i = 0; i < numBarsToShow; i++) { bars.push(<span key={i}></span>); }
    return bars;
  }

  render() {
    if (!this.props.displayName) {
      return null;
    }

    const classes = classNames(
      'condition-display',
      `condition-display--${this.slug}`,
    );

    return (
      <div
        className={classes}
        {...this.renderTooltip()}
      >
        <div className="condition-display__label">
          {this.props.displayName}
        </div>
        <div className="condition-display__bars">
          {this.renderBars()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/condition_display.tsx